import UncontrolledInputField from "../../../inputs/UncontrolledInputField";
import UncontrolledInputSelect from "../../../inputs/UncontrolledInputSelect";
import { DropdownSelect, TextInput } from "@avenueops/web-components";
import { ColumnType } from "@prisma/client";
import React from "react";
import { DeepMap, ErrorOption, FieldError } from "react-hook-form";

interface Props {
  onChange: (_: string) => void;
  error?: ErrorOption;
  columnType: ColumnType;
  value: string;
}

/**
 * The value input field for row filters. This will change based on the column type.
 */
export default function RowFilterValueInput({ onChange, columnType, value }: Props): JSX.Element {
  return columnType === ColumnType.BOOLEAN ? (
    <DropdownSelect
      name="columnType"
      size="LARGE"
      selectedValue={value}
      onChange={(value: string | undefined) => {
        if (value) {
          onChange(value);
        }
      }}
      options={[
        { label: "true", value: "true" },
        { label: "false", value: "false" },
      ]}
      onCreate={(value) => ({
        label: value,
        value: value,
      })}
    />
  ) : columnType === ColumnType.DATE ? (
    <TextInput name="columnTypeDate" placeholder={"ex. MM-DD-YYYY"} defaultValue={value} onChange={(e) => onChange(e.target.value)} />
  ) : columnType === ColumnType.NUMBER ? (
    <TextInput name="columnTypeNumber" placeholder={"ex. 4"} defaultValue={value} onChange={(e) => onChange(e.target.value)} />
  ) : (
    <TextInput name="columnTypeString" placeholder={"any text"} defaultValue={value} onChange={(e) => onChange(e.target.value)} />
  );
}
